
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { Autoplay } from 'swiper';
SwiperCore.use([Autoplay]);
export default {
  name: 'Cooperation',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      imgArr: [
        '/11.png',
        '/12.png',
        '/13.png',
        '/21.png',
        //'/22.png',
        '/23.png',
        '/31.png',
        '/32.png',
        //'/33.png',
        '/41.png',
        '/42.png',
        '/43.png',
        // '/51.png',
        //'/52.png',
        //'/53.png',
        '/61.png',
        '/62.png',
        '/63.png',
        '/71.png',
        '/72.png',
        //'/73.png',
        //'/81.png',
        '/82.png',
        //'/83.png',
        //'/91.png',
        //'/92.png',
        //'/93.png',
        '/101.png',
        '/102.png',
        '/103.png',
        '/111.png',
        '/112.png',
        '/113.png'
      ],
      showImgsArr: []
    }
  },
  created() {
    this.getShowImgs()
  },
  methods: {
    getShowImgs() {
      let newArr = []
      let smallArr = []
      this.imgArr.map((item, index) => {
        if (index != 0 && index % 3 == 0) {
          newArr.push(smallArr)
          smallArr = []
        }
        smallArr.push(item)
      })
      // console.log('newArr====', newArr)
      this.showImgsArr = newArr
    }
  }
}
